import { Components, Theme } from '@mui/material/styles';

export const MuiIconButton: Components<Theme>['MuiIconButton'] = {
  styleOverrides: {
    root: {
      height: 'var(--input-height-medium)',
      width: 'var(--input-height-medium)',
      variants: [
        {
          props: { size: 'tiny' },
          style: {
            height: 'var(--input-height-tiny)',
            width: 'var(--input-height-tiny)',
          },
        },
        {
          props: { size: 'small' },
          style: {
            height: 'var(--input-height-small)',
            width: 'var(--input-height-small)',
          },
        },
        {
          props: { size: 'large' },
          style: {
            height: 'var(--input-height-large)',
            width: 'var(--input-height-large)',
          },
        },
      ],
    },
  },
};
